var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26054 15.2237L10.4051 9.04072C10.5364 8.94106 10.6417 8.81743 10.7139 8.67832C10.7861 8.5392 10.8235 8.3879 10.8235 8.23478C10.8235 8.08166 10.7861 7.93036 10.7139 7.79124C10.6417 7.65213 10.5364 7.5285 10.4051 7.42884L2.26054 1.24584C1.48313 0.655756 0.282309 1.14498 0.282309 2.05178L0.28231 14.4196C0.28231 15.3263 1.48313 15.8156 2.26054 15.2237Z",
    fill: "#8566E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrowIcon);
export default __webpack_public_path__ + "static/media/rightarrow-icon.2995adf9ad95f42e1e5e346eb5770208.svg";
export { ForwardRef as ReactComponent };